import React, { Component, Fragment } from 'react';

import { translate } from '../Services/translation';
import ProductQuantity from './ProductQuantity';

class MiniCart extends Component {
    constructor(props) {
        super(props);
        let rows = {}
        this.props.orderRows.forEach(x => {
            rows = {
                ...rows,
                [x.rowSystemId]: x.quantity
            }
        });
        this.state = {
            editingQuantity: rows,
            removingRow: {},
            showSharePopup: false,
            shareUrl: "",
            showCopiedNotification: false
        };
    }

    handleUpdateClick(rowSystemId, currentQuantity, originalQuantity) {
        if (currentQuantity == originalQuantity) {
            return;
        }
        const changeQuantity = currentQuantity - originalQuantity;
        this.props.updateOrderRowQuantity(rowSystemId, currentQuantity, changeQuantity);
    }
    getValue(id, quantity = 1) {
        if (this.props.orderRow.quantity) {
            return this.props.orderRow.quantity
        } else {
            return quantity;
        }
        const { editingQuantity } = this.state;
        if (editingQuantity[id] == undefined) {
            return quantity
        } else {
        }
    }

    openSharePopup = () => {
        const articlesString = this.props.orderRows
            .map(orderRow => `${orderRow.articleNumber}x${orderRow.quantity}`)
            .join(',');

        const url = `${window.location.origin}${this.props.shoppingCartUrl}?products=${articlesString}`;
        this.setState({ showSharePopup: true, shareUrl: url });
    };

    copyToClipboard = () => {
        navigator.clipboard.writeText(this.state.shareUrl).then(() => {
            this.setState({ showCopiedNotification: true });

            setTimeout(() => {
                this.setState({ showCopiedNotification: false });
            }, 2000);
        });
    };

    closeSharePopup = () => {
        this.setState({ showSharePopup: false });
    };

    renderSharePopup() {
        if (!this.state.showSharePopup) return null;

        return (
            <div className="cart__share-overlay">
                <div className="cart__share-popup">
                    <div className="cart__share-header">
                        <h3 className="cart__share-title">{translate("minicart.shareheader")}</h3>
                        <i className="icon ion-ios-close-circle-outline cart__share-close-icon" onClick={this.closeSharePopup}></i>
                    </div>

                    <div className="cart__share-section">
                        <h4 className="cart__share-subtitle">{translate("minicart.link")}</h4>
                        <div className="cart__share-url-container">
                            <div className="cart__share-url-text">{this.state.shareUrl}</div>
                            <button
                                onClick={this.copyToClipboard}
                                className="cart__share-copy-button"
                            >
                                {translate("minicart.copy")}
                            </button>
                            <div className="cart__notification-wrapper">
                                <div className={`cart__copied-notification ${this.state.showCopiedNotification ? 'cart__copied-notification--visible' : ''}`}>
                                    {translate("minicart.copied")}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }


    render() {

        if (this.props.quantity > 0) {
            return <Fragment>
                <div className="cart cart--mini">
                    <a className="cart__link--block" onClick={() => this.props.toggle()}>
                        <i className="icon ion-md-cart cart__icon"></i>

                        <span className="cart__quantity">{this.props.quantity}</span>
                        <span className="cart__title">{translate('minicart.checkout')}</span>
                    </a>
                    <div className={`cart__info ${!this.props.showInfo ? 'cart__info--hidden' : ''}`}>
                        <div className="cart__header">
                            <h2>{translate('minicart.header')}</h2>
                            <i className="icon ion-ios-close-circle-outline cart__close-button" onClick={() => this.props.toggle()}></i>
                        </div>
                        <div className="cart__products">
                            {this.props.orderRows.map(orderRow => {
                                return (
                                    <div className="cart__product_row row" key={orderRow.rowSystemId}>
                                        <div className="small-3 large-3">
                                            <a className="cart__product-image" href={orderRow.url}>
                                                <img src={orderRow.image} />
                                            </a>
                                        </div>
                                        <div className="small-9 large-9">
                                            <p className="cart__product-name">{orderRow.name}</p>
                                            <div className="cart__update-quantity">
                                                {
                                                    orderRow.isFreeGift ? (
                                                        <div>
                                                            {orderRow.quantity}
                                                        </div>
                                                    ) : (
                                                        <ProductQuantity
                                                            unitDecimalDigits={0}
                                                            quantity={orderRow.quantity}
                                                            callbackParent={(newQuantity) => this.handleUpdateClick(orderRow.rowSystemId, newQuantity, orderRow.quantity)}
                                                            availableQuantity={orderRow.availableStockQuantity}
                                                            productStatus={orderRow.productStatus}
                                                            isOutgoing={orderRow.isOutgoing}
                                                        ></ProductQuantity>
                                                    )
                                                }
                                            </div>

                                            <a className="cart__delete-row" title={translate('general.remove')} onClick={() => this.props.removeOrderRow(orderRow.rowSystemId)}>
                                                <i className="icon ion-md-trash"></i>
                                            </a>
                                            {/*         
                                            <div className="cart__update-row">
                                                {!orderRow.isFreeGift &&
                                                    <a className="cart__icon--reorder" title={translate('update.price')} onClick={(event) => this.handleUpdateClick(orderRow.rowSystemId, editingQuantity[orderRow.rowSystemId] || orderRow.quantity, orderRow.quantity)}>
                                                        <i className="icon ion-md-refresh-circle"></i>
                                                    </a>
                                                }
                                            </div> */}

                                            <p className="cart__product-price">{orderRow.totalPrice}</p>
                                        </div>

                                    </div>
                                )
                            })
                            }
                        </div>
                        <div className="cart__bottom">
                            <p className="cart__total-products">{this.props.quantity} {translate('minicart.numberofproduct')}</p>
                            <p className="cart__total-price"><b>{translate('minicart.total')}</b> {this.props.orderTotal}</p>
                            <a href={this.props.checkoutUrl} className="button cart__checkout-button">{translate('minicart.checkout')}</a>
                            <button className="cart__share-button" onClick={this.openSharePopup}>
                                {translate('minicart.sharecart')}
                            </button>
                        </div>
                    </div>
                    <div className={`cart__bgoverlay ${!this.props.showInfo ? 'cart__bgoverlay--hidden' : ''}`} onClick={() => this.props.toggle()}></div>
                </div>
                {this.renderSharePopup()}
            </Fragment>
        }
        else {
            return <div className="cart cart--mini">
                <a className="cart__link--block" onClick={() => this.props.toggle()}>
                    <i className="icon ion-md-cart cart__icon"></i>

                    <span className="cart__quantity">{this.props.quantity}</span>
                    <span className="cart__title">{translate('minicart.checkout')}</span>
                </a>
                <div className={`cart__info ${!this.props.showInfo ? 'cart__info--hidden' : ''}`}>
                    <div className="cart__header">
                        <h2>{translate('minicart.header')}</h2>
                        <i className="icon ion-ios-close-circle-outline cart__close-button" onClick={() => this.props.toggle()}></i>
                    </div>
                    <div className="cart__empty-message">{translate('minicart.empty')}</div>
                </div>
                <div className={`cart__bgoverlay ${!this.props.showInfo ? 'cart__bgoverlay--hidden' : ''}`} onClick={() => this.props.toggle()}></div>
            </div>;
        }
    }


}


export default MiniCart;